export default __webpack_public_path__ + "static/media/acr.2545c84f.png";